import { TxpObject } from 'txp-data';

/**
 * Returns origin of the first entity of the TXP object as
 * origin for all the entities in an object has same value.
 * @param txpObject Txp object from which origin needs to be extracted
 */
export default function getOriginFromTxpObject(txpObject: TxpObject): string {
    if (txpObject) {
        const { txpEntities } = txpObject;
        return txpEntities[Object.keys(txpEntities)[0]].origin;
    }
    return null;
}
